import { useEffect } from "react";
import { useHistory } from "react-router-dom";

const Success = () => {
    const history = useHistory();

    useEffect(() => {
        // Redirect to the home page after the pop-up closes
        if (window.opener) {
            window.opener.location.href = "/";
            window.close();
        } else {
            history.push("/"); // Fallback for when not in a pop-up
        }
    }, [history]);

    return (
        <div>
            <h1>Payment Successful!</h1>
            <p>Redirecting to the homepage...</p>
        </div>
    );
};

export default Success;
